export default __webpack_public_path__ + "static/Dashboard-Overview-ss-20233a24b2b69a06775f076bae1a956a.png";